import { render, staticRenderFns } from "./InvoicesTable.vue?vue&type=template&id=28f293d0&"
import script from "./InvoicesTable.vue?vue&type=script&lang=js&"
export * from "./InvoicesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports